import axios from "axios";

export const getAddonAvailableQuantity = async (item_name, item_size) => {
    try {
        const config = {
            withCredentials: true,
            headers: {
                withCredentials: true,
            },
        };
        const data = await axios.post(
            `${process.env.REACT_APP_URL}/api/dispatch/addon-available-quantity`,
            {
                item_name: item_name,
                item_size: item_size
            },
            config,
        );
        return data?.data?.result;
    } catch (error) {
        console.log(error);
        return error;
        // return error?.response?.data?.result;
    }
};
